'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams, usePathname } from 'next/navigation';
import { getRouteType, type RouteType } from '@/helpers/routeType';
interface UseRouteTypeResult {
  routeType: RouteType;
  isMultiChain: boolean;
  /** Only defined on chain-specific pages. */
  chainIdentifier: string | undefined;
}

/**
 * React hook for detecting whether the current page is multi-chain or chain-specific.
 */
export function useRouteType() {
  const $ = _c(6);
  const pathname = usePathname();
  const params = useParams();
  let t0;
  if ($[0] !== pathname) {
    t0 = getRouteType(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const routeType = t0;
  const isMultiChain = routeType === "multi-chain";
  const chainIdentifier = isMultiChain ? undefined : params.chainIdentifier as string | undefined;
  let t1;
  if ($[2] !== chainIdentifier || $[3] !== isMultiChain || $[4] !== routeType) {
    t1 = {
      routeType,
      isMultiChain,
      chainIdentifier
    };
    $[2] = chainIdentifier;
    $[3] = isMultiChain;
    $[4] = routeType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}